import { BooleanMark } from 'mk2/apps/strollers/components/BooleanMark';
import { BooleanPair } from 'mk2/apps/strollers/features/other';
import { Features } from 'mk2/apps/strollers/schemas';
import * as React from 'react';
import styles from './BooleanFeature.mscss';

interface OwnProps {
    features: Features;
    feature: any;
}

export class BooleanFeature extends React.Component<OwnProps> {
    public render() {
        const { feature, features } = this.props;

        const value = feature.rawValue(features);

        switch (value) {
            case true:
            case false:
                const booleanPair: BooleanPair = [value, null];
                return (
                    <BooleanMark booleanPair={booleanPair} className={styles.BooleanFeature} />
                );
            default:
                return null;
        }
    }
}
